import * as utils from "../utils";

/**
 * Makes get requests
 * @param path string
 * @param params obj/URLSearchParams
 * @param expectJson bool
 * @returns {Promise<any>}
 */
const get = (path, params, expectJson = true, credentials = false) => {
    if (typeof params === "undefined") {
        params = new URLSearchParams();
    } else if (typeof params.append === "undefined") {
        const obj = params;
        params = new URLSearchParams();

        Object.keys(obj).forEach((k) => {
            params.append(k, obj[k])
        });
    }

    let init = { method : 'GET' };
    if(credentials){
        init['credentials'] = 'include';
    }

    return fetch(path + '?' + params.toString(), init)
        .then(response => expectJson ? response.json() : response.text());
};

const doFormData = (formData = {}) => {
    if (!(formData instanceof FormData)) {
        const obj = formData;
        formData = new FormData();

        Object.keys(obj).forEach((k) => {
            formData.append(k, obj[k])
        });
    }
    return formData;
}

const doFetch = (method, path, formData = {}, expectJson = true, credentials = false) => {
    formData = doFormData(formData);

    let init = { method : method, body: formData };
    if(credentials){
        init['credentials'] = 'include';
    }
    if(expectJson) {
        init['headers'] = { 'Accept' : 'application/json' };
    }

    return fetch(path, init)
        .then(response => expectJson ? response.json() : response.text());
};

const del = (path, formData = {}, expectJson = true, credentials = false) => {
    return doFetch('DELETE', path, formData, expectJson, credentials);
};

const post = (path, formData = {}, expectJson = true, credentials = false) => {
    return doFetch('POST', path, formData, expectJson, credentials);
};

const put = (path, formData = {}, expectJson = true, credentials = false) => {
    return doFetch('PUT', path, formData, expectJson, credentials);
};

/*
//Sin compatibilidad no funciona, así que mejor que nadie lo use por accidente
const patch = (path, formData = {}, expectJson = true, credentials = false) => {
    formData = doFormData(formData);
    return doFetch('PATCH', path, formData, expectJson, credentials);
};*/

export {
    get,
    post,
    put,
    del,
   // patch
}